.banner-success-container{display:flex;vertical-align:middle}.banner-warning-container,.banner-error-container{display:flex;justify-content:center;align-items:center}.mdc-snackbar__actions{margin-left:10px}
/*# sourceMappingURL=snack-bar.component-5LDSXAW4.css.map */
